import { render, staticRenderFns } from "./DmDriverLabelModal.vue?vue&type=template&id=6bcee813"
import script from "./DmDriverLabelModal.vue?vue&type=script&lang=js"
export * from "./DmDriverLabelModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports